import { getType } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';

import { IAccount, IOAuthApi } from '../../interfaces';
import { convertToError } from '../../utils';
import * as actions from './actions';

function* fetchAccount(api: IOAuthApi) {
  try {
    const account: IAccount = yield call(api.fetchAccount);

    yield put(actions.fetchAccountSucceeded({ account }));
  } catch (e) {
    yield put(actions.fetchAccountFailed(convertToError(e)));
  }
}

function* editAccount(api: IOAuthApi, action: ReturnType<typeof actions.editAccount>) {
  const { account } = action.payload;

  try {
    yield call(api.editAccount, account);
    const updatedAccount: IAccount = yield call(api.fetchAccount);

    yield put(actions.editAccountSucceeded({ account: updatedAccount }));
  } catch (e) {
    yield put(actions.editAccountFailed(convertToError(e)));
  }
}

export function* accountSaga(api: IOAuthApi) {
  yield takeLatest(getType(actions.fetchAccount), fetchAccount, api);
  yield takeLatest(getType(actions.editAccount), editAccount, api);
}
